// import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
import {getApiProps} from "@/lib/lib";

export default {
    state: {
        idlings_index: [],
        idlings: [],
    },
    actions: {
        fetchIdlings4Date({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today') args.date = getters.getDateToday
                //let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.date) {
                    return reject(false)
                }
                if (args.unitId > 0 && !args.force) {
                    let index = getters.getIdlingsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchIdlings4Date', args, time: Date.now() / 1000})
                if (args.date == getters.getDateToday) {
                    dispatch('setLastCall', {name: 'fetchLastIdlings', args, time: Date.now() / 1000})
                }

                let params = getApiProps('idlings', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.idlings.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeIdlings', response.data)
                            commit('setIdlingsIndex', {...args, count: response.data.length})
                            if (!args.unitId && response.data.length) {
                                // debugger
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchIdlings4Date', args, inprogress: false})
                        if (args.date == getters.getDateToday) {
                            dispatch('setLastCall', {name: 'fetchLastIdlings', args, inprogress: false})
                        }
                    });
            })
        },
        fetchIdlings4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId || !args.from || !args.to) {
                    return reject(false)
                }
                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getIdlingsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchIdlings4Date', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (args.date == getters.getDateToday) {
                    dispatch('setLastCall', {name: 'fetchLastIdlings', args, time: Date.now() / 1000})
                }

                let params = getApiProps('idlings', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.idlings.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeIdlings', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchIdlings4Date', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (args.date == getters.getDateToday) {
                            dispatch('setLastCall', {name: 'fetchLastIdlings', args, inprogress: false})
                        }
                    });
            })
        },
        fetchIdlingsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchLastIdlings', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchIdlingsChanged', args, time: Date.now() / 1000})

            // args = {...consts.querySettings.filter, ...args}
            // delete args.date
            args.force = true
            return dispatch('fetchIdlings4Date', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastIdlings', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchIdlingsChanged', args, inprogress: false})
                });
        },
        reloadIdlings({commit, dispatch}, args) {
            commit('clearIdlings')
            return dispatch('fetchIdlings4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setIdlingsIndex(state, params) {
            let i = state.idlings_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.idlings_index.push(Object.freeze({...params}))
            } else {
                state.idlings_index[i] = Object.freeze({...state.idlings_index[i], ...params})
            }
        },
        storeIdlings(state, nIdlings) {
            nIdlings = nIdlings
                .filter(p => !state.idlings.find(_p => {
                    return _p.unit_id == p.unit_id
                        && _p.time_start?.utc == p.time_start?.utc
                    // && _p.time_end?.utc == p.time_end?.utc
                }))
                .map(p => Object.freeze(p))

            // if(nIdlings.length) state.idlings.push(...nIdlings)
            if (!nIdlings.length) return false
            if (!state.idlings.length) {
                state.idlings = nIdlings
                return true
            }
            state.idlings.push(...nIdlings)

            //vue recommended
            // const chunks = arraySplitIntoChunks(nIdlings)//.reverse();
            // const pushOnRenderTask = () => {
            //     if (chunks.length === 0) return;
            //     let chunk = chunks.pop();
            //     state.idlings.push(...chunk);
            //     requestAnimationFrame(pushOnRenderTask);
            // }
            // pushOnRenderTask();
        },
        clearIdlings(state) {
            state.idlings = [];
            state.idlings_index = [];
        },
    },
    getters: {
        getIdlingsIndex(state) {
            return state.idlings_index
        },
        getIdlings(state) {
            return state.idlings
        },
        getIdlingsByIds(state) {
            return state.idlings.reduce((idlingsByIds, idling) => {
                idlingsByIds[idling.id] = idling
                return idlingsByIds
            }, {})
        },
    }
}
